<template>
  <div>
    <TableManager  @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options"/>
    <BasicTable
    :items="telNumItems"
    :fields="telNumFields"
    :filter="filter"
    :perPage="perPage"
    :currentPage="currentPage"
    v-model="totalRows"/>
    <TableManagerBottom
    :totalRows="totalRows" :perPage="perPage"
    v-model="currentPage" />
  </div>
</template>

<script>
import axiosInstance from '@/utils/api'
import BasicTable from '@/components/tables/BasicTable.vue'
import TableManager from '@/components/tables/TableManager'
import TableManagerBottom from '@/components/tables/TableManagerBottom'

export default {
  data () {
    return {
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 5,
      totalRows: 0,
      currentPage: 1,
      item: null,
      telNumItems: [],
      telNumFields: [
        {key: 'num_id', label: 'ID', sortable: true},
        {key: 'slink_id', label: this.$i18n.t('ID slink'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'number', label: this.$i18n.t('Telephone'), sortable: true},
        {key: 'incoming_trunk', label: this.$i18n.t('Incoming trunc'), sortable: true},
        {key: 'outgoing_trunk', label: this.$i18n.t('Outgoing trunc'), sortable: true},
        {key: 'pbx_id', label: this.$i18n.t('PBX ID'), sortable: true},
        {key: 'allowed_cid', label: this.$i18n.t('Allowed CID'), sortable: true}
      ]
    }
  },
  components: {
    BasicTable,
    TableManager,
    TableManagerBottom
  },
  methods: {
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    async load () {
      this.telNumItems = await axiosInstance.get(this.$store.getters.API_USERS_TEL_NUMBERS).then(response => {
        return response.data
      })
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/telephoneNum/main.vue